import { Space, Button } from 'antd';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AddFiservPaymentSettingsForm from './AddFiservPaymentSettingsForm';

export type FiservPaymentSettingsDrawerProps = {
    onClose: () => void;
    visible: boolean;
    moduleId: string;
};

const FiservPaymentSettingsDrawer = ({ onClose, visible, moduleId }: FiservPaymentSettingsDrawerProps) => {
    const { t } = useTranslation(['fiservPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('fiservPaymentModuleDetails:paymentSettingsDrawer.cancelButton')}
                    </Button>
                    <Button form="addFiservPaymentSettings" htmlType="submit" type="primary">
                        {t('fiservPaymentModuleDetails:paymentSettingsDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('fiservPaymentModuleDetails:paymentSettingsDrawer.title.create')}
            visible={visible}
            destroyOnClose
        >
            <AddFiservPaymentSettingsForm moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default FiservPaymentSettingsDrawer;

export const useFiservPaymentSettingsDrawer = (moduleId: string) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <FiservPaymentSettingsDrawer moduleId={moduleId} onClose={actions.close} visible={visible} />,
    };
};
